import {
  gnenumPATCH as PATCH,
  gnenumNSFKEY as NSFKEY,
  gnenumISDATA as ISDATA,
  gnenumISPATCHREHYDRATE as ISPATCHREHYDRATE,
  gnenumLOGPATCHJOBS as LOGPATCHJOBS,
  gnenumLOGWARNINGS as LOGWARNINGS
} from './gnenum.js'

import {
  gnreportCreate as reportCreate,
  gnreport_addreplacekey as reportChangedNodeSubtreeSet,
  gnreportNodeSubjChangedSet as reportNodeSubjChangedSet
} from '../src/gnreport.js'

import {
  gnrunrest
} from './gnrun.js'

import {
  gnaccNSMap as accNSMap,
  gnaccCache as accCache
} from './gnacc.js'

import {
  gnarrReduce as arrReduce
} from './gnarr.js'

import {
  gnedgeIdCreate as edgeIdCreate,
  gnedgeMetaGet as edgeMetaGet,
  gnedgeMetaTargetGet as edgeMetaTargetGet,
  gnedgeMetaSenderGet as edgeMetaSenderGet,
  gnedgeIdGet as edgeIdGet
} from './gnedge.js'

import {
  gnnodeosRefreshDFS,
  gnnodeosNSHydrateSuchFromChildsRefresh
} from './gnnodeos.js'

import {
  gnspecClientNSREFIs as specClientNSREFIs,
  // gnspecClientNSREFNTHIs as specClientNSREFNTHIs,
  gnspec_ischildsfold as gnspecClientNSREFCHILDKEYSFOLD
} from './gnspec.js'

import {
  gnnodeNSTargetsGet as nodeNSTargetsGet,
  gnnodeNSSendersGet as nodeNSSendersGet,
  gnnodeEdgeResolveComposite as nodeEdgeResolveComposite
} from './gnnode.js'

const JOBSTARTSENDERS = 'gn:mstartsenders'
const JOBSTARTTARGETS = 'gn:mstarttargets'
const JOBEDGEREFRESH = 'gn:medgerefresh'
const JOBEDGESEND = 'gn:medgesend'

const jobs = {}

const gnpatchJobProcess = async (ss, cfg, gr, rep, jobspec) => {
  const jobtype = jobspec[0]
  const jobopts = jobspec[1]
  const job = jobs[jobtype]

  if (typeof job !== 'function')
    throw new Error(`job type un-supported: ${jobtype}`)

  if (cfg.logger.levels[LOGPATCHJOBS]) {
    cfg.logger.log(jobtype, jobopts, rep)
  }

  return job(ss, cfg, gr, rep, jobopts)
}

const gnpatchJobsProcess = async (ss, cfg, gr, rep, queue) => {
  if (!queue.length)
    return [gr, rep]

  // [graph, report]
  const res = await gnpatchJobProcess(ss, cfg, gr, rep, queue[0])

  queue.shift() // mutate the queue
  return gnpatchJobsProcess(ss, cfg, res[0], res[1], queue)
}

const gnpatchQueueAdd = (cfg, jobtype, jobargs) => (
  cfg.jobqueue.push([jobtype, jobargs]),
  cfg)

// the older job-call style follows a more-familiar pattern which might
// brought back later, so saving here in case useful
// ```
// job = gnpatchQueueAdd(cfg, cfg, gr, jobtype, { pxuarr }, jobreport)
// await job.start()
// ```
const gnpatchCycleStart = async (ss, cfg, gr, pxuarr, report) => {
  const jobreport = report || reportCreate(pxuarr[0][0])

  pxuarr.forEach(pxuelem => {
    const node = gr.get(pxuelem[0])
    if (!node) {
      if (cfg.logger.levels[LOGWARNINGS])
        cfg.logger.warn(`[!!!] node not found, ${pxuelem[0]}`)

      return null
    }

    const jobtype = nodeNSTargetsGet(node).length
      ? JOBSTARTTARGETS
      : JOBSTARTSENDERS

    gnpatchQueueAdd(cfg, jobtype, pxuelem)
  })

  return gnpatchJobsProcess(ss, cfg, gr, jobreport, cfg.jobqueue)
}

// pxuelem === [KEY, NS, { ...values }]
// ex,
// ```
// [ '/label', 'subj', { value: 'value-2' } ]
// ```
const gnpatchjobStartTargets = (ss, cfg, gr, rep, pxuelem) => {
  const jobedgesendarr = []
  const key = pxuelem[0]
  const targetns = pxuelem[1]
  const targetnsprops = pxuelem[2]
  const targetnd = gr.get(key)

  gr = gr.set(key, accNSMap[targetns]
    .assignExisting(targetnd, targetnsprops))

  nodeNSTargetsGet(targetnd).forEach(edgeout => {
    Object.keys(targetnsprops).forEach(prop => {
      const edgeSenderProp = edgeMetaSenderGet(edgeout)[2]

      // where target props are '{ a, b, c }',
      // do not send 'a' and 'b' values to edge 'c'
      if (edgeSenderProp === prop) {
        jobedgesendarr.push([
          PATCH,
          edgeIdGet(edgeout),
          edgeMetaGet(edgeout),
          targetnsprops[prop]
        ])
      }
    })
  })

  if (jobedgesendarr.length) {
    gnpatchQueueAdd(cfg, JOBEDGESEND, {
      edgexarr: jobedgesendarr
    })
  }

  return [gr, rep]
}

// [[ '/label', 'subj', { value: 'value-2' }]]
//
// 1) update the current node
// 2) mark current node as updated
// 3) update upstream data node
// 4) start job publishing data from upstream data node
const gnpatchjobStartSenders = (ss, cfg, gr, rep, pxuelem) => {
  const jobedgesendarr = []
  const key = pxuelem[0]
  const targetns = pxuelem[1]
  const targetnsprops = pxuelem[2]
  const targetnd = gr.get(key)

  // TODO throw error when targetnsprops misspelled or undefined (difficult)
  // at target node. doing so is less-straighforward than it would seem.
  // some namespaces are defined literally, some defined dynamically,
  // some composed of properties that are defined dynamically, others
  // statically

  gr = gr.set(key, accNSMap[targetns]
    .assignExisting(targetnd, targetnsprops))

  // update values at current node... and create jobs to reverse-update
  // nodes from which the data came

  // for each of these values, build a reverse-edge for distributing the value
  nodeNSSendersGet(targetnd).forEach(edgein => {
    // edge.meta ex,
    // ```
    // [['/data', 'subj', 'datavalue'], ['/label', 'full', 'value']]
    // ```
    const edgeinsender = edgeMetaSenderGet(edgein)
    const edgeintarget = edgeMetaTargetGet(edgein)
    const edgeintargetns = edgeintarget[1]
    const edgeintargetprop = edgeintarget[2]
    const edgeintargetspec = (edgeintarget[3] || {})

    // TODO use uinav onclick to build feature
    // if no props found, show warning in logs
    if (edgeintargetns === targetns
      && edgeintargetprop in targetnsprops
    ) {
      // no spec on 'in' edges. check the at the sender.
      // sender value is an array and target is not
      const targetval = targetnsprops[edgeintargetprop]
      const edgeval = typeof edgeintargetspec.COMPOSITEIDX === 'number'
        ? nodeEdgeResolveComposite(
          gr, edgeinsender, edgeintargetspec.COMPOSITEIDX, targetval)
        : targetval

      jobedgesendarr.push([
        PATCH,
        edgeIdCreate(edgeintarget, edgeinsender),
        [edgeintarget, edgeinsender.slice(0, 3)], // remove meta
        edgeval
      ])
    }
  })

  if (jobedgesendarr.length) {
    gnpatchQueueAdd(cfg, JOBEDGESEND, { edgexarr: jobedgesendarr })
  }

  return [gr, rep]
}

const gnpatchjobEdgeRefresh = async (ss, cfg, gr, rep, jobopts) => {
  const edgexarr = jobopts.edgexarr
  const jobedgesendarr = []

  gr = await arrReduce(edgexarr, async (gr, edgex) => {
    const edgexmeta = edgex[2]
    const edgextarget = edgexmeta[1]
    const edgextargetkey = edgextarget[0]
    const edgextargetns = edgextarget[1]
    const edgextargetprop = edgextarget[2]
    const edgextargetnd = gr.get(edgextargetkey)
    const edgextargetvalstart = edgex[3]

    rep = reportChangedNodeSubtreeSet(rep, edgextargetkey)

    if (edgextargetnd.get(ISDATA)) {
      const grrefreshed = await gnnodeosNSHydrateSuchFromChildsRefresh(
        ss, cfg, gr, edgextargetnd)
      const ndrefreshed = grrefreshed.get(edgextargetkey)

      nodeNSTargetsGet(ndrefreshed).forEach(edgeout => {
        const edgeoutsender = edgeMetaSenderGet(edgeout)
        const edgeoutsenderns = edgeoutsender[1]
        const edgeoutsenderprop = edgeoutsender[2]

        jobedgesendarr.push([
          PATCH,
          edgeIdGet(edgeout),
          [edgeoutsender, edgeMetaTargetGet(edgeout)],
          accNSMap[edgeoutsenderns] // edgextargetval
            .propget(ndrefreshed, edgeoutsenderprop)
        ])
      })

      return grrefreshed
    }

    // set the new nsfkey value for fkey-conditional childs at refresh
    gr = gr.set(edgextargetkey, accNSMap[edgextargetns]
      .propset(edgextargetnd, edgextargetprop, edgextargetvalstart))

    // return [gr, nd, rp]
    const res = await gnnodeosRefreshDFS(
      ss, cfg, gr, gr.get(edgextargetkey), rep)

    return res[0]
  }, gr)

  if (jobedgesendarr.length) {
    gnpatchQueueAdd(cfg, JOBEDGESEND, {
      edgexarr: jobedgesendarr
    })
  }

  return [gr, rep]
}

// follow the edges and apply the values to the node
//
const gnpatchjobEdgeSend = async (ss, cfg, gr, rep, jobopts) => {
  const edgexarr = jobopts.edgexarr
  const jobedgesendcache = {}
  const jobedgesendarr = []
  const jobedgerefresharr = []

  gr = await arrReduce(edgexarr, async (acc, edgex) => {
    const edgexmeta = edgex[2]
    const edgextarget = edgexmeta[1]
    const edgextargetkey = edgextarget[0]
    const edgextargetnd = gr.get(edgextargetkey)
    const edgextargetns = edgextarget[1]
    const edgextargetprop = edgextarget[2]
    const edgextargetspec = (edgextarget[3] || {}).spec
    const edgextargetvalstart = edgex[3]

    // nodes for which pgonsubj will be called
    rep = reportNodeSubjChangedSet(rep, edgextargetkey)

    if (gnspecClientNSREFCHILDKEYSFOLD(edgextargetspec, edgextargetns)
      // ISPATCHREHYDRATE used by nodes w/ child subtrees affected by changes
      // to parent state, such as 'objls'. For example, a component rendering
      // a preview-image based on selection from a list somewhere else.
      //
      // Usually `true` for part-type nodes containing childs
      || accCache.propget(edgextargetnd, ISPATCHREHYDRATE)
    ) {
      if (!jobedgesendcache[edgextargetkey]) {
        jobedgesendcache[edgextargetkey] = true
        jobedgerefresharr.push(edgex)
      }

      return gr
    }

    if (edgextargetns === NSFKEY) {
      if (!jobedgesendcache[edgextargetkey]) {
        jobedgesendcache[edgextargetkey] = true
        jobedgerefresharr.push(edgex)
      }

      return gr
    }

    const edgextargetval = specClientNSREFIs(edgextargetspec) ? (
      await gnrunrest(
        ss, cfg, gr, edgextargetnd, {}, edgextargetspec, edgextargetvalstart)
    ) : edgextargetvalstart

    nodeNSTargetsGet(edgextargetnd).forEach(edgeout => {
      const edgeoutsender = edgeMetaSenderGet(edgeout)
      const edgeoutsenderns = edgeoutsender[1]
      const edgeoutsenderprop = edgeoutsender[2]

      if (edgextargetns === edgeoutsenderns
        && edgextargetprop === edgeoutsenderprop
      ) {
        jobedgesendarr.push([
          PATCH,
          edgeIdGet(edgeout),
          [edgeoutsender, edgeMetaTargetGet(edgeout)],
          edgextargetval
        ])
      }
    })

    gr = gr.set(edgextargetkey, accNSMap[edgextargetns]
      .propset(edgextargetnd, edgextargetprop, edgextargetval))

    return gr
  }, gr)

  if (jobedgesendarr.length) {
    gnpatchQueueAdd(cfg, JOBEDGESEND, {
      edgexarr: jobedgesendarr
    })
  }

  if (jobedgerefresharr.length) {
    gnpatchQueueAdd(cfg, JOBEDGEREFRESH, {
      edgexarr: jobedgerefresharr
    })
  }

  return [gr, rep]
}

Object.assign(jobs, {
  [JOBSTARTSENDERS]: gnpatchjobStartSenders,
  [JOBSTARTTARGETS]: gnpatchjobStartTargets,
  [JOBEDGEREFRESH]: gnpatchjobEdgeRefresh,
  [JOBEDGESEND]: gnpatchjobEdgeSend
})

export {
  gnpatchCycleStart as default,
  gnpatchCycleStart
}
